import { isNil } from "lodash-es";

import { StatusIndicator, StatusIndicatorProps } from "./StatusIndicator";

export interface BooleanStatusIndicatorProps extends StatusIndicatorProps {
  value: boolean | null | undefined;
}

export function BooleanStatusIndicator({ value, ...otherProps }: BooleanStatusIndicatorProps) {
  return (
    <StatusIndicator
      color={
        (isNil(value) ? (th) => th.palette.text.main : undefined) ??
        (value === true ? (th) => th.palette.success.main : undefined) ??
        (value === false ? (th) => th.palette.error.main : undefined)
      }
      {...otherProps}
    />
  );
}
